<template>
    <section class="cusFlowList">
        <section class="card_list">
            <div class="card">
                <div class="item" v-if="cusFlow.channelType == 1">
                    <div class="label"><p>创建人员</p></div>
                    <div class="info"><p>{{cusFlow.creatorName}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>渠道类型</p></div>
                    <div class="info"><p>{{cusFlow.channelType | f_channelType}}</p></div>
                </div>
                <div class="item" v-if="cusFlow.channelType == 1">
                    <div class="label"><p>渠道名称</p></div>
                    <div class="info"><p>{{cusFlow.channelName}}</p></div>
                </div>
                <div class="item" v-if="cusFlow.channelType == 0">
                    <div class="label"><p>推广名称</p></div>
                    <div class="info"><p>{{cusFlow.promotionName}}</p></div>
                </div>
            </div>
            <div class="card">
                <div class="item">
                    <div class="label"><p>匹配时间</p></div>
                    <div class="info"><p>{{cusFlow.matchTime}}</p></div>
                </div>
                <div class="item" v-if="cusFlow.channelType == 0">
                    <div class="label"><p>推广计划</p></div>
                    <div class="info"><p>{{cusFlow.planName}}</p></div>
                </div>
            </div>
            <div class="card">
                <div class="item">
                    <div class="label"><p>初次分配到团队时间</p></div>
                    <div class="info"><p>{{cusFlow.initialTeamDistributionTime}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>初次分配到团队方式</p></div>
                    <div class="info"><p>{{cusFlow.initialTeamDistribution | f_distributionType}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>当前所属团队</p></div>
                    <div class="info"><p>{{cusFlow.currentTeamName}}</p></div>
                </div>
            </div>
            <div class="card">
                <div class="item">
                    <div class="label"><p>初次分配到业务员时间</p></div>
                    <div class="info"><p>{{cusFlow.initialSalesmanDistributionTime}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>初次分配到业务员方式</p></div>
                    <div class="info"><p>{{cusFlow.initialSalesmanDistribution | f_distributionType}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>当前所属业务员</p></div>
                    <div class="info"><p>{{cusFlow.currentSalesmanName}}</p></div>
                </div>
            </div>
        </section>
	</section>
</template>

<script>
import customerServer from "api/customer";

export default {
    name: "cusFlowList",
    props: {id: Number},
    data() {
        return {
            cusFlow: {}
		};
    },    
    created() {
        this.getInfo();
	},
	mounted() {
	},	
    methods: {
        getInfo() {
            customerServer.getCusFlow({id: this.id}).then((res) => {
                this.cusFlow = res.data
            })
        },
    },
};
</script>

<style lang="scss">
	.cusFlowList {
        .card {
            margin-bottom: 22px;
            background-color: #FDFDFD;
            border-radius: 24px;

            .head {
                padding: 16px 30px;
                border-bottom: 1px solid #E9F0F8;

                h3 {
                    color: #303030;
                    font-size: 17px;
                    line-height: 22px;
                    font-weight: 500;
                }
            }

            .item {
                margin-left: 30px;
                padding: 16px 30px 16px 0;
                border-bottom: 1px solid #E9F0F8;
                display: flex;
                justify-content: space-between;

                .label p {
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 400;
                    color: #4D5B80;
                }

                .info {
                    max-width: 70%;
                }

                .info p {
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 400;
                    color: #000;
                    text-align: right;
                }
            }

            .item:last-child {
                border-bottom: 0;
            }
        }

        .nodata_class {
            background-color: #f8f8f8;
            display: flex;
            align-items: center;
            justify-content: center;

            .no_data {
                position: relative;

                img {
                    width: 252px;
                    display: inline-block;
                }

                p {
                    padding-top: 22px;
                    color: #4d5b80;
                    font-size: 16px;
                    text-align: center;
                }
            }
        }
	}
</style>


// WEBPACK FOOTER //
// src/views/components/CusFlowList.vue